import { getZonePathFromLocationSelector } from '../../../Utils'

import {
  AVAILABLE_FEATURE_FLAGS,
  ENABLE_FLEET_MANAGEMENT,
  ENABLE_MAPS,
  ENABLE_REPORTS,
  ENABLE_STATUS_PAGE,
  hasFeatureFlagEnabled
} from '@/Util/FeatureFlagsUtils'

export const site = ({
  level,
  locationSelector,
  permissions,
  strings,
  currentUser
}) => {
  const zonePath = getZonePathFromLocationSelector({ level, locationSelector })
  const zone = locationSelector.get(level)
  const organization = locationSelector.get('organization')

  const enableTrialModeView = permissions?.trial_mode_view || false

  const enableFleetManagement = hasFeatureFlagEnabled(
    currentUser,
    AVAILABLE_FEATURE_FLAGS[ENABLE_FLEET_MANAGEMENT],
    organization.id
  )

  const enableMaps = hasFeatureFlagEnabled(
    currentUser,
    AVAILABLE_FEATURE_FLAGS[ENABLE_MAPS],
    organization.id
  )

  const enableReports = hasFeatureFlagEnabled(
    currentUser,
    AVAILABLE_FEATURE_FLAGS[ENABLE_REPORTS],
    organization.id
  )

  const enableStatusPage = hasFeatureFlagEnabled(
    currentUser,
    AVAILABLE_FEATURE_FLAGS[ENABLE_STATUS_PAGE],
    organization.id
  )

  const routes = [
    {
      to: `/zones/${zonePath}`,
      text: strings.dashboard,
      icon: 'dashboard',
      activeOnly: true
    },
    {
      to: `/zones/${zonePath}/data`,
      text: strings.databoard,
      icon: 'insights',
      activeOnly: true
    },
    {
      to: `/zones/${zonePath}/map`,
      text: strings.map,
      icon: 'travel_explore',
      visible: enableMaps
    },
    {
      to: `/zones/${zonePath}/status`,
      text: strings.status,
      icon: 'traffic',
      activeOnly: true,
      exact: false,
      visible: enableStatusPage
    },
    {
      to: `/zones/${zonePath}/trial-mode`,
      text: strings.trial_mode_view,
      icon: 'science',
      activeOnly: true,
      exact: false,
      visible: enableTrialModeView
    },
    {
      to: `/zones/${zonePath}/reports`,
      text: strings.reports,
      icon: 'data exploration',
      visible: enableReports,
      activeOnly: true
    },
    {
      to: `/admin/zones/${zonePath}/details`,
      text: strings.settings,
      icon: 'settings'
    },
    {
      to: `/admin/zones/${zonePath}/devices`,
      text: strings.devices,
      icon: 'important devices',
      visible: permissions.sensor && permissions.sensor_management
    },
    {
      to: `/admin/zones/${zonePath}/managers`,
      text: strings.managers,
      icon: 'supervisor account',
      visible: permissions.user && permissions.user_management
    },
    {
      to: `/admin/zones/${zonePath}/thresholds`,
      text: strings.thresholds,
      icon: 'data thresholding',
      visible: permissions.sensor && permissions.sensor_thresholds,
      activeOnly: true
    },
    {
      to: `/admin/zones/${zonePath}/fleet-management`,
      text: strings.fleet_management,
      icon: 'device_hub',
      visible:
        permissions.godMode ||
        (enableFleetManagement &&
          permissions.sensor &&
          permissions.sensor_management),
      activeOnly: true
    },
    {
      to: `/zones/${zonePath}/video-feeds`,
      text: strings.video_feeds,
      icon: 'smart display',
      visible: permissions.sensor_cameras,
      activeOnly: true
    },
    {
      to: '/blueprint',
      text: strings.blueprint,
      icon: 'border inner',
      activeOnly: true,
      visible: false
    },
    {
      to: `/operations/${zonePath}/crops`,
      text: strings.crops,
      icon: 'psychiatry',
      visible: permissions.operations_harvest,
      activeOnly: true
    },
    {
      to: `/operations/${zonePath}/harvest`,
      text: strings.harvest,
      icon: 'compost',
      visible: permissions.operations_harvest,
      activeOnly: true,
      routes: [
        {
          to: `/operations/${zonePath}/harvest/plans`,
          text: strings.plans,
          icon: 'pending actions',
          visible: permissions.operations_plans
        }
      ]
    },
    {
      to: '/fertigation',
      text: strings.fertigation,
      icon: 'fertile',
      _visible: permissions.operations_fertilizer,
      activeOnly: true,
      visible: false
    }
  ]

  return {
    text: locationSelector.get(level).name,
    title: strings[level],
    icon: 'view quilt',
    routes: routes.filter(r => !r.activeOnly || zone.status === 'active')
  }
}
